module.exports = __webpack_public_path__ + "img/tratamiento.e70f6a7a.png";